module.exports = __webpack_public_path__ + "img/bergamlaim_kirche.e28b1729.jpg";